import { render, staticRenderFns } from "./share-receipt-modal.vue?vue&type=template&id=287383b2"
import script from "./share-receipt-modal.vue?vue&type=script&lang=js"
export * from "./share-receipt-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports